// extracted by mini-css-extract-plugin
module.exports = {"container":"Badge_container__GXfIf","content":"Badge_content__Ue8Y7","positionBottomRight":"Badge_positionBottomRight__1JJDw"};